const photosTemplate = require('templates/widgets/personalized/photos.hbs');
const morePhotosTemplate = require('templates/widgets/personalized/more-photos.hbs');
const indexTemplate = require('templates/widgets/personalized/index.hbs');

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

L2H.PersonalizedWidget = class PersonalizedWidget extends L2H.Widget {
  constructor($container, photosURL, options) {
    super(...arguments);
    this.$container = $container;
    this.photosURL = photosURL;
    this.fetchingPhotos = false;
    this.photos = [];
    this.brandPhotoURL = options.bpURL;
    this.brandPhotoClickURL = options.bpClickURL || L2H.galleryURL;
    this.nextPage = 1;

    var fetcher = null;
    if (options.lm === "1") {
      this.loadMoreEnabled = true;
      fetcher = this.fetchPhotos.bind(this);
    }

    this.renderIndex();

    this.modalView = new L2H.PhotoModalView(this.$container, 'personalized-widget', fetcher, options);

    const self = this;
    this.fetchPhotos({first10: true}).done(function() {
      self.modalView.setPhotos(self.photos);
      return self.$container.addClass('widget-loaded');
    });

    this.bindEvents();
  }

  loadMorePhotos() {
    return (this.photos.length >= 10);
  }

  fetchPhotos(options) {
    options = options || {};
    let per, padding, updateNextPage;

    if (options.first10) {
      per =  10;
      padding =  0;
      updateNextPage = false
    } else {
      per = 30;
      padding = 10;
      updateNextPage = true
    }

    const deferred = new $.Deferred();

    if (this.fetchingPhotos) {
      deferred.resolve();
      return deferred;
    }


    this.fetchingPhotos = true;

    if (this.loadMoreEnabled) {
      this.hideLoadMoreLink();
      this.showLoadingSpinner();
    }

    const self = this;
    $.ajax({
      url: this.photosURL,
      data: {page: this.nextPage, per: per, padding: padding},
      dataType: "jsonp"
    }).done(function(data) {
      $.merge(self.photos, data.photos);

      if (updateNextPage) {
        self.nextPage = data.meta.nextPage;
      }

      self.appendPhotos(data.photos);
      self.fetchingPhotos = false;

      if (self.loadMoreEnabled) {
        self.hideLoadingSpinner();
        if (self.nextPage) {
          self.showLoadMoreLink();
        }
      }

      let brokenPhotoChecker = new L2H.BrokenPhotoCheck();
      brokenPhotoChecker.call(data.photos);

      return deferred.resolve();
    });

    return deferred;
  }

  appendPhotos(photos) {
    const template = this.photos.length > 10 ? morePhotosTemplate : photosTemplate;
    const renderedPhotos = template({photos, brandPhotoURL: this.brandPhotoURL, preferences: this.preferences, brandPhotoClickURL: this.brandPhotoClickURL});

    this.$container.find('.l2h-photos').append(renderedPhotos);
  }

  renderIndex() {
    const renderedIndex = indexTemplate({photos: this.photos, preferences: this.preferences, loadMoreEnabled: this.loadMoreEnabled });
    return this.$container.html(renderedIndex);
  }

  bindEvents() {
    const self = this;

    this.$container.on('click', '[data-l2h-load-more] a', function(e) {
      e.preventDefault();
      self.fetchPhotos();
    });
  }

  showLoadMoreLink() {
    this.$container.find('[data-l2h-load-more]').removeClass('l2h-hidden');
  }

  hideLoadMoreLink() {
    this.$container.find('[data-l2h-load-more]').addClass('l2h-hidden');
  }

  showLoadingSpinner() {
    this.$container.find('.l2h-loading-spinner').removeClass('l2h-hidden');
  }

  hideLoadingSpinner() {
    this.$container.find('.l2h-loading-spinner').addClass('l2h-hidden');
  }
};
